// import './Header.scss' // Removed for version update

const Notification = () => {
  return (
    <svg width='21' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.4297 20.31H1.62974C1.01974 20.31 0.459739 19.97 0.179739 19.43C-0.100261 18.89 -0.0502608 18.23 0.309739 17.72C1.04974 16.67 1.47974 15.41 1.47974 14.27V9.55C1.47974 4.84 5.30974 1 10.0297 1C14.7497 1 18.5797 4.84 18.5797 9.55V14.27C18.5797 15.4 19.0097 16.66 19.7497 17.72C20.1097 18.22 20.1597 18.87 19.8797 19.42C19.5997 19.97 19.0397 20.31 18.4297 20.31ZM1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87ZM2.30974 18.31H17.7497C16.9897 17.04 16.5797 15.63 16.5797 14.28V9.55C16.5797 5.94 13.6397 3 10.0297 3C6.41974 3 3.47974 5.94 3.47974 9.55V14.27C3.47974 15.63 3.06974 17.04 2.30974 18.31Z'
        fill='url(#paint0_linear)'
      />
      <path
        d='M18.4297 20.31H1.62974C1.01974 20.31 0.459739 19.97 0.179739 19.43C-0.100261 18.89 -0.0502608 18.23 0.309739 17.72C1.04974 16.67 1.47974 15.41 1.47974 14.27V9.55C1.47974 4.84 5.30974 1 10.0297 1C14.7497 1 18.5797 4.84 18.5797 9.55V14.27C18.5797 15.4 19.0097 16.66 19.7497 17.72C20.1097 18.22 20.1597 18.87 19.8797 19.42C19.5997 19.97 19.0397 20.31 18.4297 20.31ZM1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87ZM2.30974 18.31H17.7497C16.9897 17.04 16.5797 15.63 16.5797 14.28V9.55C16.5797 5.94 13.6397 3 10.0297 3C6.41974 3 3.47974 5.94 3.47974 9.55V14.27C3.47974 15.63 3.06974 17.04 2.30974 18.31Z'
        fill='#004B8D'
      />
      <path
        d='M10.0295 24C11.2595 24 12.2895 23.14 12.5395 22H7.51953C7.76953 23.14 8.79953 24 10.0295 24Z'
        fill='url(#paint1_linear)'
      />
      <path
        d='M10.0295 24C11.2595 24 12.2895 23.14 12.5395 22H7.51953C7.76953 23.14 8.79953 24 10.0295 24Z'
        fill='#004B8D'
      />
      <circle cx='16' cy='5' r='4' fill='url(#paint2_linear)' />
      <circle cx='16' cy='5' r='4' fill='#EB193F' />
      <circle cx='16' cy='5' r='4' stroke='white' strokeWidth='2' />
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='20.443'
          y1='20.31'
          x2='-3.79803'
          y2='12.7068'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#676BFC' />
          <stop offset='1' stopColor='#4620CA' />
        </linearGradient>
        <linearGradient
          id='paint1_linear'
          x1='7.51493'
          y1='23.0004'
          x2='12.5434'
          y2='23.0004'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F09819' />
          <stop offset='1' stopColor='#EDCE4D' />
        </linearGradient>
        <linearGradient
          id='paint2_linear'
          x1='12.9945'
          y1='5.0012'
          x2='19.0047'
          y2='5.0012'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F09819' />
          <stop offset='1' stopColor='#EDCE4D' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Notification;
